import { render } from "./MainPersonalPayment.vue?vue&type=template&id=62f6fb43&scoped=true"
import script from "./MainPersonalPayment.vue?vue&type=script&lang=js"
export * from "./MainPersonalPayment.vue?vue&type=script&lang=js"

import "./MainPersonalPayment.vue?vue&type=style&index=0&id=62f6fb43&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f6fb43"]])

export default __exports__